export default function ContentsRecoms() {
  return (
    <>
      <div className="side2">
        <div id="button-get-recoms" className="button-mode none"></div>
      </div>
      <article className="side2 multireco" id="contents-recoms"></article>
    </>
  );
}
